<template>
  <div>
    <div
      v-if="!isDirectPayment"
      id="reward-items-lists"
      :class="{ 'border-bottom': !hideBottomBorder }"
    >
      <div
        v-for="{ key, label, subLabel, caption, items } in itemGroups"
        :id="`items-${key}-items`"
        :key="key"
        :class="{ 'bg-reversed': backgroundReversed }"
        class="items-group px-1 px-sm-2"
      >
        <display-if-catalog-has-physical-items>
          <h4
            class="items-group-heading svp-font-weight-medium"
            tabindex="0"
          >
            {{ label }}
            <span
              v-if="subLabel"
              class="items-group-subheading svp-font-weight-normal"
            >
              {{ subLabel }}
            </span>
          </h4>
        </display-if-catalog-has-physical-items>

        <div
          v-if="caption"
          class="pb-4 caption"
          tabindex="0"
        >
          {{ caption }}
        </div>
        <v-card
          v-for="item in items"
          :key="item.id"
          class="mb-4 white pa-4"
          elevation="4"
        >
          <cart-item
            :cart-item="item"
            :editable="editable"
            class="items-group-item"
          />
        </v-card>
      </div>
    </div>

    <div v-else>
      <div
        v-for="{ key, items } in itemGroups"
        :id="`items-${key}-items`"
        :key="key"
      >
        <v-card
          v-for="item in items"
          :key="item.id"
          class="mb-4 white pa-4"
          elevation="4"
        >
          <cart-item
            :cart-item="item"
            :editable="editable"
            class="items-group-item"
          />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import CartItem from '../cart/ItemControl.vue'
import DisplayIfCatalogHasPhysicalItems from '../shared/catalog/DisplayIfCatalogHasPhysicalItems'

export default {
  name: 'RewardLists',
  components: {
    DisplayIfCatalogHasPhysicalItems,
    CartItem
  },
  props: {
    itemGroups: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    backgroundReversed: {
      type: Boolean,
      default: false
    },
    hideBottomBorder: {
      type: Boolean,
      default: false
    },
    isDirectPayment: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

#reward-items-lists {
  &.border-bottom {
    border-bottom: 1px solid $tangoLtGray;
  }

  .items-group {
    padding: 20px;

    &:not(.bg-reversed):nth-child(even) {
      background-color: $tangoLtGray;
    }

    &.bg-reversed:nth-child(odd) {
      background-color: $tangoLtGray;
    }

    .items-group-heading {
      color: $tangoTextPrimary;
      font-size: $font-size-md;
      margin-bottom: 15px;

      .items-group-subheading {
        font-size: $font-size-sm;
        color: $tangoTextPrimary;
      }
    }

    .items-group-item {
      position: relative;
      min-height: 80px;

      &:not(:first-of-type) {
        margin-top: 15px;
      }
    }
  }
}
</style>
